import React, { useEffect } from 'react';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'medium'
}) => {
  // Fechar com Esc. Efeito antes do early return para não violar as regras de hooks.
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const sizeClasses = {
    small: 'max-w-md',
    medium: 'max-w-lg',
    large: 'max-w-4xl'
  };

  const modalSize = sizeClasses[size] || 'max-w-lg';

  return (
    <dialog className={`modal ${isOpen ? 'modal-open' : ''}`}>
      {/* Coluna flex com overflow-hidden: o que rola é o corpo, não a caixa.
          O .modal-box do Daisy rola inteiro por padrão, e num formulário alto
          isso levava o rodapé para fora da tela — em monitor baixo o botão de
          confirmar ficava escondido e parecia que o modal não tinha ação.
          O max-h substitui o 100vh do Daisy: como .modal usa padding:0, um
          modal alto encostava nas bordas e o rodapé fixo ficaria colado na
          tela. */}
      <div
        className={`modal-box ${modalSize} animate-fade-in flex flex-col overflow-hidden max-h-[calc(100vh-4rem)]`}
        onClick={(e) => e.stopPropagation()}
      >
        <form method="dialog">
          <button 
            className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 z-10" 
            onClick={onClose}
            aria-label="Fechar"
          >
            ✕
          </button>
        </form>
        
        {title && (
          <h3 className="font-bold text-lg mb-4 pr-8 text-base-content shrink-0">{title}</h3>
        )}
        
        {/* min-h-0 é o que permite ao flex encolher este bloco abaixo da altura
            natural do conteúdo — sem ele o overflow-y nunca entra em ação. */}
        <div className="py-4 flex-1 min-h-0 overflow-y-auto">
          {children}
        </div>
        
        {footer && (
          <div className="flex justify-end gap-2 border-t border-base-300 pt-4 mt-4 shrink-0">
            {footer}
          </div>
        )}
      </div>
      <form method="dialog" className="modal-backdrop" onClick={onClose}>
        <button>close</button>
      </form>
    </dialog>
  );
};
